'use strict';

module.exports = require('./Checkbox');


/*****************
 ** WEBPACK FOOTER
 ** ./~/.1.4.3@rc-checkbox/lib/index.js
 ** module id = 168
 ** module chunks = 0
 **/